'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});


var getInitial = function getInitial(str) {
  return str.charAt(0).toUpperCase();
};

var getInitials = exports.getInitials = function getInitials(_ref) {
  var _ref$firstName = _ref.firstName,
      firstName = _ref$firstName === undefined ? '' : _ref$firstName,
      _ref$lastName = _ref.lastName,
      lastName = _ref$lastName === undefined ? '' : _ref$lastName;
  return '' + getInitial(firstName) + getInitial(lastName);
};

var getFullName = exports.getFullName = function getFullName(_ref2) {
  var _ref2$firstName = _ref2.firstName,
      firstName = _ref2$firstName === undefined ? '' : _ref2$firstName,
      _ref2$lastName = _ref2.lastName,
      lastName = _ref2$lastName === undefined ? '' : _ref2$lastName;
  return firstName && lastName ? firstName + ' ' + lastName : '' + firstName;
};

var makePossessive = exports.makePossessive = function makePossessive(name) {
  return name.slice(-1) === 's' ? name + '\'' : name + '\'s';
};